import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import './index.css'

/**
 * Detecta mudança de versão do build e força o browser a pegar a última versão (sem cache).
 *
 * Requer um arquivo público: /version.json
 * Exemplo:
 * { "version": "2026-02-05T00:00:00Z" }
 */
async function ensureLatestBuild() {
  const VERSION_URL = '/version.json'
  const STORAGE_KEY = 'app_build_version'

  try {
    // Busca a versão sem cache (cache-bust + no-store)
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        'cache-control': 'no-cache',
        pragma: 'no-cache',
      },
    })

    if (!res.ok) return

    const data = (await res.json()) as {version?: string}
    const remoteVersion = data?.version
    if (!remoteVersion) return

    const localVersion = localStorage.getItem(STORAGE_KEY)

    // Primeira vez: salva e segue
    if (!localVersion) {
      localStorage.setItem(STORAGE_KEY, remoteVersion)
      return
    }

    // Mudou: limpa caches e recarrega
    if (localVersion !== remoteVersion) {
      localStorage.setItem(STORAGE_KEY, remoteVersion)

      // Limpa Cache Storage (PWA / Workbox / etc.)
      if ('caches' in window) {
        const keys = await caches.keys()
        await Promise.all(keys.map((k) => caches.delete(k)))
      }

      // Remove service workers (se houver)
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations()
        await Promise.all(regs.map((r) => r.unregister()))
      }

      // Força reload com cache-bust na URL
      const url = new URL(window.location.href)
      url.searchParams.set('_v', remoteVersion)
      window.location.replace(url.toString())
    }
  } catch {
    // se falhar (offline etc.), não trava o app
  }
}

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()

;(async () => {
  // Opção mais garantida: checa antes de renderizar
  await ensureLatestBuild()

  const container = document.getElementById('root')
  if (container) {
    createRoot(container).render(
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </MetronicI18nProvider>
      </QueryClientProvider>
    )
  }
})()
